import Button from "@components/Button";
import type { JSX } from "solid-js";
import { styled } from "solid-styled-components";

export const ButtonsGrid = styled.div`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(5, 1fr);
  @media only screen and (max-width: 756px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media only screen and (max-width: 512px) {
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const ShareButton = styled(Button)<{ bg?: JSX.CSSProperties["background-color"] }>`
  width: 100%;
  aspect-ratio: 1 / 1;
  height: unset;
  border-radius: 5px;
  ${({ bg }) => (bg ? `background-color:${bg}` : "")};
  img {
    width: 70px;
  }
`;
